<po-page-default > 
    
    <po-loading-overlay *ngIf="carregando"
        p-screen-lock="true"
        p-text="Carregando" >
    </po-loading-overlay>


</po-page-default>
